var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalingWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 102,
    viewBox: "0 0 118 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1867 5.06422L1.54772 88.7736C0.753436 90.113 0.334566 91.6331 0.333255 93.1807C0.331943 94.7284 0.748238 96.2491 1.54025 97.5898C2.33226 98.9305 3.47206 100.044 4.84496 100.818C6.21786 101.592 7.77544 102 9.36098 102H108.639C110.224 102 111.782 101.592 113.155 100.818C114.528 100.044 115.668 98.9305 116.46 97.5898C117.252 96.2491 117.668 94.7284 117.667 93.1807C117.665 91.6331 117.246 90.113 116.452 88.7736L66.8131 5.06422C66.0201 3.72691 64.8808 2.61665 63.5094 1.84481C62.1381 1.07296 60.5829 0.666656 58.9999 0.666656C57.4169 0.666656 55.8617 1.07296 54.4904 1.84481C53.119 2.61665 51.9797 3.72691 51.1867 5.06422ZM58.9999 32.6667C61.9454 32.6667 64.3332 35.0545 64.3332 38V62C64.3332 64.9455 61.9454 67.3333 58.9999 67.3333C56.0544 67.3333 53.6666 64.9455 53.6666 62V38C53.6666 35.0545 56.0544 32.6667 58.9999 32.6667ZM64.9999 80C64.9999 83.3137 62.3136 86 58.9999 86C55.6862 86 52.9999 83.3137 52.9999 80C52.9999 76.6863 55.6862 74 58.9999 74C62.3136 74 64.9999 76.6863 64.9999 80Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalingWarningTriangle);
export default __webpack_public_path__ + "static/media/SignalingWarningTriangle.64989a711bca15136b772bda949c82b5.svg";
export { ForwardRef as ReactComponent };